import classNames from "classnames";
import type { PropsWithChildren } from "react";
import * as React from "react";
import type { LinkProps } from "@remix-run/react";
import type { CKButtonProps } from "@commercekit/ui";
import { CKButton } from "@commercekit/ui";
import WvLink from "./WvLink";
import WvLoadingCircle from "./WvLoadingCircle";

export type RbButtonTheme =
  | "link"
  | "primary"
  | "secondary"
  | "tertiary"
  | "darkblue"
  | "simple";
type WvButtonProps = Omit<
  CKButtonProps<LinkProps & React.RefAttributes<HTMLAnchorElement>>,
  "Link" | "Loading"
> & {
  theme?: RbButtonTheme;
};

const WvButton = ({
  className,
  theme = "primary",
  ...props
}: PropsWithChildren<WvButtonProps>) => {
  const _className = classNames(
    "inline-block text-xsm uppercase vertical-middle font-gotham text-center relative disabled:!cursor-not-allowed",
    {
      "leading-11 px-6.25 text-blue-light hover:underline": theme === "link",
    },
    {
      "text-white bg-blue-light rounded px-4 py-2.5 leading-6":
        theme === "primary",
    },
    {
      "text-blue-light rounded px-4 py-2 leading-6 border border-blue-light border-2":
        theme === "secondary",
    },
    {
      "text-blue-light rounded px-4 py-2 leading-6 border border-gray-lighter border-1":
        theme === "tertiary",
    },
    {
      "text-white bg-darkblue rounded px-4 py-2.5 leading-6":
        theme === "darkblue",
    },
    {
      "text-darkblue bg-white rounded px-4 py-2.5 leading-6":
        theme === "simple",
    },
    className
  );

  return (
    <CKButton
      Link={WvLink}
      Loading={() => <WvLoadingCircle />}
      className={_className}
      {...props}
    />
  );
};

export default WvButton;
